var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-blue"},[_c('img',{staticClass:"main-blue-background",attrs:{"src":require("@img/header.png")}}),_c('main-user-info-view',{staticClass:"main-blue-user-info"})],1),_c('div',{staticClass:"main-white"},[_c('main-list',{on:{"onCellClick":_vm.onClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }